import { render, staticRenderFns } from "./AyudaPasoAPaso.vue?vue&type=template&id=80848828&scoped=true&"
import script from "./AyudaPasoAPaso.vue?vue&type=script&lang=js&"
export * from "./AyudaPasoAPaso.vue?vue&type=script&lang=js&"
import style0 from "./AyudaPasoAPaso.vue?vue&type=style&index=0&id=80848828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80848828",
  null
  
)

export default component.exports